export default __webpack_public_path__ + "static/media/bdswissSCReal03_downloadMT4.391df1e5.png";